var map = {
	"./buddy_blank_big": 204,
	"./buddy_blank_big.png": 204,
	"./business-preview": 205,
	"./business-preview.jpg": 205,
	"./cut_h": 206,
	"./cut_h.png": 206,
	"./cut_v": 207,
	"./cut_v.png": 207,
	"./favicon": 208,
	"./favicon.png": 208,
	"./login-bg": 209,
	"./login-bg.webp": 209,
	"./logo_bizjumping": 210,
	"./logo_bizjumping.png": 210,
	"./logo_galaxus": 211,
	"./logo_galaxus.png": 211,
	"./nav-logo-nuvola": 212,
	"./nav-logo-nuvola.png": 212,
	"./nav-logo-prando": 213,
	"./nav-logo-prando.png": 213,
	"./nav-logo_bizjumping": 214,
	"./nav-logo_bizjumping.png": 214,
	"./swiss_cross": 215,
	"./swiss_cross.png": 215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 246;